export function formatText(text: string): string {
  if (!text) return ''
  const words = text.split('_')

  const formattedText = words.reduce((acc, el) => (acc += `${el[0].toUpperCase() + el.slice(1).toLowerCase()} `), '')

  return formattedText
}
